import { Stack, Typography } from "@mui/material";
import {
  Dialog,
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import React from "react";
import { useTranslation } from "react-i18next";

export type ConfirmAPIKeyAction = "rotate" | "delete";

interface ConfirmAPIKeyActionDialogProps {
  action: ConfirmAPIKeyAction;
  apiKeyId: string;
  loading: boolean;
  onConfirm: () => Promise<void>;
  onClose: VoidFunction;
}

export const ConfirmAPIKeyActionDialog: React.FC<
  ConfirmAPIKeyActionDialogProps
> = ({ action, apiKeyId, loading, onConfirm, onClose }) => {
  const { t } = useTranslation();
  const spacing = useSpacing();
  const typography = useTypography();
  const tokens = useFoundationColorTokens();
  const isRotate = action === "rotate";

  return (
    <Dialog
      open
      title={t(
        isRotate
          ? "externalPublicApis.apiKeyManagementRotateDialogTitle"
          : "externalPublicApis.apiKeyManagementDeleteDialogTitle",
      )}
      primaryButtonText={t(
        isRotate
          ? "externalPublicApis.apiKeyManagementRotateKey"
          : "externalPublicApis.apiKeyManagementDeleteKey",
      )}
      primaryButtonColor="destructive"
      onPrimaryButtonClick={onConfirm}
      secondaryButtonText={t("common.cancel")}
      onSecondaryButtonClick={onClose}
      isSecondaryButtonDisabled={loading}
      disableBackdropClick
      width="560px"
    >
      <Stack padding={spacing.spaceLG}>
        <Typography
          {...typography.b1}
          color={tokens.label}
          sx={{ overflowWrap: "anywhere" }}
        >
          {t(
            isRotate
              ? "externalPublicApis.apiKeyManagementRotateDialogDescription"
              : "externalPublicApis.apiKeyManagementDeleteDialogDescription",
            { apiKeyId },
          )}
        </Typography>
      </Stack>
    </Dialog>
  );
};
